module.exports = __webpack_public_path__ + "static/media/man.d7fd9e0b.png";